<template>
  <ValidationObserver ref="observer" v-slot="{ passes }" slim>
    <form method="get" @submit.prevent="passes(submit)" class="search-jobs">
      <ValidationProvider name="form.reference" rules="reference" slim>
        <div class="form-group" slot-scope="{ errors }" :class="{ 'has-error': !!errors.length }">
          <label for="reference">
            <span class="label">{{$t('homepage_reference_label')}}</span>
            <input type="text" id="reference" name="reference" v-model="form.reference">
          </label>
          <span class="error" aria-live="polite">{{ errors[0] }}</span>
        </div>
      </ValidationProvider>
      <ValidationProvider name="form.careerPath" rules="" slim>
        <div class="form-group" slot-scope="{ errors }">
          <label for="careerPath">
            <span class="label">{{$t('global_jobfamily_label')}}</span>
            <select class="select-css" id="careerPath" name="careerPath" v-model="form.careerPath">
              <option :value="careerPath.value" v-for="careerPath in careerPaths" :key="careerPath.value">{{ $te(careerPath.key) ? $t(careerPath.key) : careerPath.key }}</option>
            </select>
          </label>
          <span class="error" aria-live="polite">{{ errors[0] }}</span>
        </div>
      </ValidationProvider>
      <ValidationProvider name="form.contractType" rules="" slim>
        <div class="form-group" slot-scope="{ errors }">
          <label for="contractType">
            <span class="label">{{$t('global_positiontype_label')}}</span>
            <select class="select-css" id="contractType" name="contractType" v-model="form.contractType">
              <option :value="contractType.value" v-for="contractType in contractTypes" :key="contractType.value">{{ $te(contractType.key) ? $t(contractType.key) : contractType.key }}</option>
            </select>
          </label>
          <span class="error" aria-live="polite">{{ errors[0] }}</span>
        </div>
      </ValidationProvider>
      <ValidationProvider name="form.country" rules="" slim>
        <div class="form-group" slot-scope="{ errors }">
          <label for="country">
            <span class="label">{{$t('global_country_label')}}</span>
            <select class="select-css" id="country" name="country" v-model="form.country">
              <option :value="country.value" v-for="country in countries" :key="country.value">{{ $te(country.key) ? $t(country.key) : country.key }}</option>
            </select>
          </label>
          <span class="error" aria-live="polite">{{ errors[0] }}</span>
        </div>
      </ValidationProvider>
      <core-button class="primary" v-text="$t('homepage_cta_submit')"></core-button>
    </form>
  </ValidationObserver>
</template>

<script>

import { ValidationProvider, ValidationObserver } from 'vee-validate'
import careerPaths from '@/assets/data/careerPaths'
import contractTypes from '@/assets/data/contractTypes'
import { getCountryList } from '@/services/contentService'

export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data () {
    return {
      careerPaths,
      contractTypes,
      countries: [],
      form: {
        reference: '',
        careerPath: 'all',
        contractType: 'all',
        country: 'all',
        text: ''
      }
    }
  },
  methods: {
    async submit () {
      try {
        this.$router.push({
          name: 'job-offers',
          query: {
            reference: this.htmlEntities(this.form.reference),
            searchpositiontype: this.htmlEntities(this.form.careerPath),
            searchjobgenerallist: this.htmlEntities(this.form.contractType),
            country: this.htmlEntities(this.form.country),
            search: this.htmlEntities(this.form.text)
          }
        })
      } catch (error) {
        console.error(error)
      }
    },
    async fetchSearchJobData () {
      this.countries = await getCountryList()
    },
    htmlEntities (str) {
      return String(str).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;')
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler: 'fetchSearchJobData'
    }
  }
}
</script>

<style lang="scss" scoped>
.search-jobs {
  margin: 0 auto;
  width: 63rem;
  max-width: 100%;
  .form-group {
    @media screen and (min-width: $mq-medium) {
      margin-bottom: 3rem;
    }
  }
  .btn {
    display: flex;
    width: 36rem;
    max-width: 100%;
    margin: 4rem auto 0 auto;
  }
}
</style>
